import React, { useEffect } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import * as ApiWebServices from "data/InternalWebServices/ApiWebServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_INTEGRATEDSECURITY } from "pages/Login/LoginPage";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function IntegratedSecurityLogin(props) {
  const { actionSuccessfull, actionError, setIsLoading, targetUri } = props;
  const loginFailedText = translate("loginIntegrated.failed", "Login failed!");

  useEffect(() => {
    loginIntegrated();
  }, []);

  async function loginIntegrated() {
    try {
      setIsLoading(true);
      let userSID = await ApiWebServices.fetchIntegratedSecurityUserSID();
      let result = await BosIdentityServices.fetchAuthenticate(userSID, encodeValue("-"), targetUri);
      if (!result || !result.token) throw new Error("NO TOKEN RECEIVED");
      props.bosUserActions.setBosUser({
        newDisplayName: result.userDisplayName,
        newPersistIn: "session"
      });
      actionSuccessfull(LOGINTYPE_INTEGRATEDSECURITY, result.startUri, null, result.enableLaunchpad);
    } catch (error) {
      props.bosUserActions.clearBosUser();
      console.error(loginFailedText + " (" + error + ")");
      actionError(loginFailedText);
      setIsLoading(false);
    }
  }

  const encodeValue = value => {
    return btoa(value);
  }

  return (
    <LoginHeader title={translate("loginIntegrated.title", "Logging in")} description={translate("loginIntegrated.description", "Checking Integrated Security...")} />
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(IntegratedSecurityLogin);
